import { useTranslation } from '../../context/LanguageContext';
import '../policy/policy.scss';

const Privacy = () => {
  const { content } = useTranslation();
  const p = content.privacyPage;

  return (
    <main className="policy-page">
      <section className="policy-hero section-full">
        <div className="container">
          <h1 className="policy-hero__title">{p.title}</h1>
          <p className="policy-hero__updated">{p.updated}</p>
        </div>
      </section>

      <section className="policy-body section-full">
        <div className="container">
          <p className="policy-body__intro">{p.intro}</p>
          <div className="policy-list">
            {p.sections.map((item) => (
              <article className="policy-item" key={item.heading}>
                <h2>{item.heading}</h2>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Privacy;
